var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSparklingIcon = function SvgSparklingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.493 1.74c-.072-.189-.205-.312-.414-.405a.758.758 0 0 0-.984.373L1.547 5.154a.758.758 0 0 0 .374.983.758.758 0 0 0 .984-.374l1.548-3.445a.652.652 0 0 0 .04-.578ZM10.699 9.755a.768.768 0 0 0-.992-.446l-3.518 1.337a.768.768 0 1 0 .546 1.438l3.518-1.337c.402-.196.59-.614.446-.992ZM10.918 19.63c-.072-.19-.205-.312-.414-.406L7.06 17.676a.758.758 0 0 0-.984.373.758.758 0 0 0 .374.984l3.445 1.548a.758.758 0 0 0 .984-.374c.094-.208.112-.388.04-.578Z",
    fill: "#E59400"
  })));
};
export default SvgSparklingIcon;